

















































































// types
import { Component, Vue } from 'vue-property-decorator'
import type { UserActivity } from '~/domains/user/User.types'

// utils
import { getFeedRoute } from '~/utils/routesGenerator'
import { BASE_DOMAIN } from '~/configs/app'
import { useUserService } from '~/domains/user/UserService'
import { useUserStorePorts } from '~/platform/user/UserStorePortsAdapter'
import { checkIsSuperUserByLogin } from '~/utils/user'
import useFriendsService from '~/domains/friends/FriendsService'
import { useFriendsStorePorts } from '~/platform/friends/FriendsStorePortsAdapter'
import { UserRelationEnum } from '~/domains/friends/UserRelationEnum'

// components
import Alert from '~/components/UI/Alert.vue'
import Card from '~/components/UI/Card.vue'

@Component({
  components: {
    Card,
    Alert,
    BBClue: () => import('~/components/BB/BBClue.vue')
  },
  head () {
    return {
      link: [
        {
          rel: 'canonical',
          href: BASE_DOMAIN + getFeedRoute({
            userLogin: this.$storeModules.diary.currentUser!.login
          })
        }
      ],
      meta: [
        {
          name: 'robots',
          content: 'noindex, nofollow'
        }
      ]
    }
  },
  async fetch () {
    this.activity = await useUserService().fetchDiaryActivity(useUserStorePorts(this.$storeModules))
  },
  fetchOnServer: false
})
export default class UserDiaryActivityPage extends Vue {
  // из asyncData
  activity: UserActivity[] = []

  get hasNoActivity () {
    return !this.activity || !this.activity.length
  }

  get isSuper () {
    return checkIsSuperUserByLogin(this.$storeModules.auth.user?.login)
  }

  get isCurrentUser () {
    return this.$storeModules.diary.currentUser?.id === this.$storeModules.auth.userIdOrNull
  }

  // BBDEV-1119: можно ли писать владельцу дневника в ЛС (для ссылки в активности).
  // undefined/true → можно; блокирует только явный false от бэка.
  get canWriteToCurrentUser () {
    return this.$storeModules.diary.currentUser?.canWritePm !== false
  }

  get isActivityPrivate () {
    return this.$storeModules.diary.currentUser?.info?.isShowActions === '0' && !this.isCurrentUser && !this.isSuper
  }

  get isActivityForFriends () {
    return this.$storeModules.diary.currentUser?.info?.isShowActions === '2' && !this.$storeModules.diary.relation?.friend && !this.isCurrentUser && !this.isSuper
  }

  getAttrsByItem (item) {
    switch (item.type) {
      case 1:
        return {
          icon: 'common/comment'
        }
      case 2:
        return {
          icon: 'common/answer'
        }
      case 3:
        return {
          icon: 'common/friends'
        }
      case 4:
        return {
          icon: 'common/community'
        }
      case 5:
        return {
          icon: 'post/pencil'
        }
      case 6:
        return {
          icon: 'post/pencil'
        }
    }

    return {
      icon: 'user/user'
    }
  }

  freindUser () {
    useFriendsService().updateDiaryUserRelation(UserRelationEnum.Friend, useFriendsStorePorts(this.$storeModules))
  }
}
